const btnCheckout = document.getElementById("checkout");
setTimeout(() => {
  BSS_B2B.cart.fixer(JSON.parse($("#bss-b2b-store-data").html()), false, false);
}, 500);
if (btnCheckout) {
  btnCheckout.disabled = true;
  setTimeout(() => {
    btnCheckout.disabled = false;
  }, 6000);
}

if(typeof BSS_B2B != undefined) {
    if(window.location.pathname.includes("/pages/")) {
        let loop = setInterval(() =>{
            const submitBtn = $(".bss-b2b-rf-submit-button .btn");
            if(submitBtn.length) {
                clearInterval(loop);
                submitBtn.val("ABSENDEN");
            }
        }, 300);
        setTimeout(() =>{
            clearInterval(loop);
        }, 7000)
    }
}
